import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUpdatePlatformAppClientScopesMutation = createMutationHook(
  PlatformAppsApiClient.updatePlatformAppClientScopes,
  {
    mutationKey: ['updatePlatformAppClientScopes'],
  },
)

export const useUpdatePlatformAppClientScopes = () => {
  const queryClient = useQueryClient()
  const { updatePlatformAppClientScopesMutation } = useUpdatePlatformAppClientScopesMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
    },
  })

  return {
    updatePlatformAppClientScopes: updatePlatformAppClientScopesMutation.mutate,
    isLoading: updatePlatformAppClientScopesMutation.isLoading,
  }
}
